/**
 * Comparación canónica del nombre de empresa entre Personal y Contratos Marco.
 * Sola fuente de verdad para el join `usuario.empresa === contrato.contratistaNombre`.
 *
 * Tolera diferencias accidentales que NO son ambigüedad real:
 *   - Mayúsculas / minúsculas
 *   - Espacios al inicio/fin o múltiples espacios
 *   - Punto final ("S.A.S" vs "S.A.S.")
 *   - Comas finales
 *
 * NO tolera diferencias semánticas (p.ej. "SAS" vs "S.A.S" se consideran distintos).
 */
export function normalizarEmpresa(s: string | null | undefined): string {
  if (!s) return "";
  return s.trim().replace(/[.,\s]+$/u, "").replace(/\s+/g, " ").toLowerCase();
}

export function mismaEmpresa(a: string | null | undefined, b: string | null | undefined): boolean {
  const na = normalizarEmpresa(a);
  if (!na) return false;
  return na === normalizarEmpresa(b);
}
